"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompoundField = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const Css_1 = require("../../Css");
/** Internal component to help create compound fields */
function CompoundField({ children }) {
    if ((children === null || children === void 0 ? void 0 : children.length) !== 2) {
        throw global.Error("CompoundField requires two children components");
    }
    const commonStyles = Css_1.Css.df.aic.fs1.maxwPx(550).bt.bb.bGray300.$;
    const internalProps = { compound: true };
    return ((0, jsx_runtime_1.jsxs)("div", { css: {
            ...Css_1.Css.df.$,
            "&:focus-within > div:nth-of-type(2)": Css_1.Css.bgLightBlue700.$, // Separation line when inputs are focused
        }, children: [(0, jsx_runtime_1.jsx)("div", { css: {
                    ...commonStyles,
                    ...Css_1.Css.bl.borderRadius("4px 0 0 4px").$,
                    "&:focus-within": Css_1.Css.bLightBlue700.$,
                }, children: (0, react_1.cloneElement)(children[0], {
                    internalProps,
                }) }), (0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.wPx(1).flexNone.bgGray300.$ }), (0, jsx_runtime_1.jsx)("div", { css: {
                    ...commonStyles,
                    ...Css_1.Css.fg1.br.borderRadius("0 4px 4px 0").$,
                    "&:focus-within": Css_1.Css.bLightBlue700.$,
                }, children: (0, react_1.cloneElement)(children[1], {
                    internalProps,
                }) })] }));
}
exports.CompoundField = CompoundField;
